export function trimString(value: string | null | undefined): string {
  return (value ?? '').trim();
}

/** Converts a string to title case (first letter of each word capitalised). */
function toTitleCase(value: string): string {
  return value
    .toLowerCase()
    .replace(/\b([a-z])/g, (_match, first: string) => first.toUpperCase());
}

/**
 * Formats a raw string to title case if it is all-caps, otherwise returns it trimmed.
 * Returns '' for null/empty.
 */
export function formatAllCapsLabel(value: string | null | undefined): string {
  const trimmed = trimString(value);
  if (!trimmed) return '';
  if (trimmed === trimmed.toUpperCase()) return toTitleCase(trimmed);
  return trimmed;
}

export const lineClampSx = {
  display: '-webkit-box',
  lineClamp: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
};
